import { z } from 'zod';
import type { DTO } from '@/type-utils';
import type { BasicHistoricOrder } from '@/services/isomorphic/OrderLookupService/data-structures';
import { BasicHistoricOrderUnionSchema } from '../../isomorphic/OrderLookupService/data-structures/schemas';
import type { IOrderHistory } from './IOrderHistory';
import type { IOrderLookupParams } from './IOrderLookupParams';
import { PageableDTOSchema } from '../traits/schemas';

/** Zod schema for {@link IOrderLookupParams}. */
export const OrderLookupParamsSchema = z.object({
  userUUID: z.string(),
  orderID: z.string().nullish(),
  email: z.string().nullish(),
  zipCode: z.string().nullish(),
  lookupID: z.string().nullish()
}) satisfies z.ZodType<IOrderLookupParams>;

/**
 * Zod schema for the DTO of {@link IOrderHistory}.
 * It combines pageable properties with order history specific properties.
 */
export const OrderHistorySchema = PageableDTOSchema(
  BasicHistoricOrderUnionSchema
).extend({
  lookupParams: OrderLookupParamsSchema.optional()
}) satisfies z.ZodType<DTO<IOrderHistory<BasicHistoricOrder>>>;
